import React, { useEffect, useState } from "react"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import { SpinnerElement } from "@front-shared/elements/spinner.element"

import { GENERAL_CONFIG } from "../../../config/general.config"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { selectedPracticeRoleSelector } from "../../../store/selectors/selectedPracticeRole.selector"
import { practiceConfigurationsGet } from "../../../store/thunks/practiceConfigurations.thunks"

import warningRedIcon from "@front-shared/assets/images/icons/warning-red.svg"

export const PayerMappingsUnavailableComponent: React.FunctionComponent =
    () => {
        const dispatch = useAppDispatch()
        const selectedPracticeRole = useAppSelector(
            selectedPracticeRoleSelector,
        )

        const [isLoading, setIsLoading] = useState<boolean>(true)

        // Before we show the unavailable alert, we can try one more time to get the practice configuration
        useEffect(() => {
            const practice = selectedPracticeRole?.practice

            if (!practice) {
                setIsLoading(false)

                return
            }

            dispatch(
                practiceConfigurationsGet({
                    payload: practice,
                    onFinally: () => {
                        setIsLoading(false)
                    },
                }),
            )
        }, [])

        if (isLoading) {
            return <SpinnerElement containerClassName="mt-[32px] text-center" />
        }

        return (
            <div className="py-[24px]">
                <div className="flex items-center justify-center">
                    <img
                        className="mr-[8px] w-[16px] h-[16px]"
                        src={warningRedIcon}
                        alt=""
                    />

                    <PrimaryText
                        className="relative top-[2px]"
                        typography="textSemibold"
                        size={18}
                    >
                        Payer mappings are temporarily unavailable
                    </PrimaryText>
                </div>

                <div className="mt-[8px] max-w-[550px] mx-auto">
                    <PrimaryText centered typography="text">
                        Please check back in a few minutes. If the problem
                        persists, contact us at{" "}
                        <a href={`mailto:${GENERAL_CONFIG.supportEmail}`}>
                            {GENERAL_CONFIG.supportEmail}
                        </a>
                        .
                    </PrimaryText>
                </div>

                <ButtonElement
                    htmlType="button"
                    type="link"
                    className="mt-[16px] flex justify-center"
                    onClick={() => {
                        window.location.reload()
                    }}
                >
                    <PrimaryText
                        typography="buttonText"
                        color={NIRVANA_COLORS.brand.vibrantPurple}
                        underline
                        className="cursor-pointer"
                    >
                        Try again
                    </PrimaryText>
                </ButtonElement>
            </div>
        )
    }
